<template>
    <tooltip v-if="!$tools.isEmpty(comBranch)" right>              
      <v-avatar class="mr-2" :color="comBranch.color" size="10" style="margin-top:-1px"/> <span v-if="noText===undefined">{{ comBranch.name }}</span>
      <template v-slot:content>
        {{comBranch.name}}
      </template>
    </tooltip>
</template>
<script>
import Tooltip from "@/componentsV2/base/Tooltip.vue";

export default {
  components: {
    Tooltip
  },
  props: [
    'comBranch',
    'noText'
  ]
}
</script>